import React from 'react'
import BillPayDataGrid from 'src/components/BillPayDataGrid/BillPayDataGrid'
import TableEmptyState, {
  TableEmptyStateDesigns,
} from 'src/components/TableEmptyState/TableEmptyState'
import { CheckboxProps } from 'src/components/VirtualCardsBox/VirtualCardsBox'
import { VirtualCardsFiltersBody } from 'src/components/VirtualCardsBoxAndLinks/VirtualCardsBoxAndLinks'
import { VirtualCardListModel } from 'src/models/virtualCard.models'
import { VirtualCardPermissions } from 'src/models/virtualCardPermissions.models'
import { InfiniteScrollProps } from 'src/types'

interface BillPayTableProps {
  virtualCards: VirtualCardListModel[]
  virtualCardsPermissions?: Array<{
    permissions: VirtualCardPermissions[]
    virtualCardId: string
  }>
  sortableProps?: {
    setSort: (field: string) => void
    sortBy?: string
    sortDescending?: boolean
  }
  checkboxProps?: CheckboxProps
  infiniteScrollProps?: InfiniteScrollProps<VirtualCardsFiltersBody>
  filtersBody?: VirtualCardsFiltersBody
  clientHeight?: number
  emptyStateDesign: TableEmptyStateDesigns
}

const BillPayTable: React.FC<BillPayTableProps> = (props) => {
  const isEmpty =
    props.virtualCards.length === 0 && props.infiniteScrollProps?.complete

  return (
    <>
      {!isEmpty && (
        <BillPayDataGrid
          sortableProps={props.sortableProps}
          virtualCards={props.virtualCards}
          virtualCardsPermissions={props.virtualCardsPermissions}
          infiniteScrollProps={props.infiniteScrollProps}
          filters={props.filtersBody}
          clientHeight={props.clientHeight}
        />
      )}
      {isEmpty && <TableEmptyState design={props.emptyStateDesign} />}
    </>
  )
}

export default BillPayTable
